<template>
  <MaskLayer>
    <Slider class="w-75" @close="close">
      <div class="container-fluid p-0 mw-100 flex-grow-1 overflow-auto">
        <div class="h-100 overflow-auto row no-gutters">
          <div class="col-3 p-0 h-100 overflow-auto">
            <div class="h-100 border-right border-light overflow-auto d-flex flex-column">
              <div class="py-3 px-4">
                <h5 v-t="'auth.roleEdit.title'" class="mb-4" />
                <div class="position-relative">
                  <div class="mb-3">
                    <b-form-group>
                      <h6 class="font-size-md text-gray600">
                        <span class="text-danger ml-n1">*</span>{{ $t('auth.roleEdit.editRoleName') }}
                      </h6>
                      <b-input v-model="role.name" size="sm" class="rounded-pill" :state="(error.name || '') !== '' ? false : null" @input="inputName" />
                      <div v-if="(error.name || '') !== ''" class="invalid-feedback d-block mt-0 mb-2">
                        {{ error.name }}
                      </div>
                    </b-form-group>
                    <b-form-group>
                      <h6 class="font-size-md text-gray600">
                        {{ $t('auth.roleEdit.editRoleDesc') }}
                      </h6>
                      <b-textarea v-model="role.desc" size="sm" class="rounded-md" :state="(error.desc || '') !== '' ? false: null" @input="inputDesc" />
                      <div v-if="(error.desc || '') !== ''" class="invalid-feedback d-block mt-0 mb-2">
                        {{ error.desc }}
                      </div>
                    </b-form-group>
                    <h6 class="font-size-md text-gray600">
                      {{ $t('auth.roleEdit.editParentRole') }}
                    </h6>
                    <b-form-select
                      v-model="role.parentId"
                      :options="roleOptions"
                      size="sm"
                      class="w-100 rounded-pill"
                    />
                  </div>
                  <div class="mb-3">
                    <h6 v-t="'auth.roleEdit.userCount'" class="font-size-md text-gray600" />
                    <h6 class="font-size-md">
                      {{ role.userCount || 0 }}
                    </h6>
                  </div>
                  <div class="mb-3">
                    <h6 v-t="'auth.roleEdit.creater'" class="font-size-md text-gray600" />
                    <h6 class="font-size-base">
                      {{ role.creater }}
                    </h6>
                  </div>
                  <div class="mb-3">
                    <h6 v-t="'auth.roleEdit.updater'" class="font-size-md text-gray600" />
                    <h6 class="font-size-base">
                      {{ role.updater }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="px-4 pb-3">
                <b-button
                  :variant="tab === 'RoleFeature' ? 'light' : 'outline-light'"
                  class="w-100 py-0 mb-2 d-flex align-items-center text-secondary position-relative"
                  draggable=""
                  @click="tab = 'RoleFeature'"
                >
                  <div class="image-panel image-panel-0 bg-none">
                    <i class="material-icons-outlined md-18">assessment</i>
                  </div>
                  <span v-t="'auth.roleEdit.authority'" class="font-size-md text-truncate" />
                </b-button>
              </div>
            </div>
          </div>
          <RoleFeature v-if="tab === 'RoleFeature'" v-model="role.features" :role-id="role.id" />
        </div>
      </div>
      <FixedBottomBtn class="bg-white p-3">
        <div class="d-flex justify-content-between">
          <div>
            <button
              v-auth="['delete']"
              class="ml-2 btn btn-sm btn-outline-light rounded-pill border-0 d-flex align-items-center"
              :disabled="newRole"
              :style="deleteButtonStyle"
              @click="deleteRole"
            >
              <span class="text-secondary material-icons-outlined md-18 mr-1">delete</span>
              <span v-t="'common.delete'" class="text-secondary" />
            </button>
          </div>
          <div>
            <button class="ml-2 btn btn-sm btn-outline-light rounded-pill" @click="tryClose">
              <span v-t="'common.cancel'" class="px-3 text-secondary" />
            </button>
            <button v-auth="['edit']" class="ml-2 btn btn-sm btn-success rounded-pill" @click="save">
              <span v-t="'common.save'" class="px-3" />
            </button>
          </div>
        </div>
      </FixedBottomBtn>
    </Slider>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import Slider from '@/components/Slider.vue';
import FixedBottomBtn from '@/components/FixedBottomBtn.vue';
import PermissionService from '@/services/PermissionService';
import RoleFeature from '@/components/Auth/Role/RoleFeature.vue';

export default {
  components: {
    MaskLayer,
    Slider,
    FixedBottomBtn,
    RoleFeature
  },
  props: ['roleId', 'mode'],
  data() {
    return {
      role: {
        id: this.roleId,
        parentId: null,
        name: '',
        desc: '',
        creater: '',
        updater: '',
        userCount: 0,
        features: undefined
      },
      tab: '',
      origin: { ...this.role },

      roleOptions: [],

      error: {
        name: null,
        desc: null
      },

      saving: false
    };
  },
  computed: {
    newRole() {
      return (this.role.id || '') === '' || this.mode === 'clone';
    },
    deleteButtonStyle() {
      const style = {};
      if (this.newRole) {
        style.cursor = 'default';
      }
      return style;
    }
  },
  watch: {
    'role.features': {
      handler(newVal, oldVal) {
        if ((newVal || null) !== null && (oldVal || null) === null) {
          this.origin.features = JSON.parse(JSON.stringify(newVal));
        }
      }
    }
  },
  mounted() {
  },
  created() {
    // 取得角色資料
    this.loadAsync();
    // 設置角色清單選單
    this.initRoleOptionsAsync();
  },
  methods: {
    async tryClose() {
      let confirm = true;
      if (this.different()) {
        confirm = await this.$popup.confirmAsync(this.$t('auth.roleEdit.confirmDrop'));
      }

      if (confirm) {
        this.close();
      }
    },
    close() {
      this.$emit('close');
    },
    initRole() {
      this.role.name = '';
      this.role.desc = '';
      this.role.features = null;
      this.role.userCount = 0;
      this.role.creater = '';
      this.role.updater = '';
    },
    // 取得角色資料
    async loadAsync() {
      await this.$loading(async () => {
        const originTab = this.tab;
        this.tab = '';
        this.initRole();
        if ((this.role.id || '') !== '') {
          const role = await PermissionService.GetRoleAsync(this.role.id);
          this.role.id = role.roleId;
          this.role.parentId = role.parentId || null;
          this.role.name = role.name || this.role.name;
          this.role.desc = role.desc || this.role.desc;
          this.role.userCount = role.userCount || this.role.userCount;
          this.role.creater = role.creater || this.role.creater;
          this.role.updater = role.updater || this.role.updater;
        }

        this.origin = { ...this.role };
        this.setTab(originTab);
      });
    },
    // 設置角色清單選單
    async initRoleOptionsAsync() {
      await this.$loading(async () => {
        const roles = await PermissionService.GetRoleSelectionsAsync();
        const roleOptions = roles.data.filter((role) => role.id !== this.roleId)
          .map((role) => ({
            value: role.id,
            text: role.name
          }));
        this.roleOptions = [
          { value: null, text: this.$t('common.pleaseChoose') },
          ...roleOptions,
        ];
      });
    },
    async setTab(originTab) {
      await this.$loading(async () => {
        await this.$nextTick(() => {
          this.tab = originTab || 'RoleFeature';
        });
      });
    },
    inputName() {
      if ((this.error.name || '') !== '') {
        this.validateName();
      }
    },
    inputDesc() {
      if ((this.error.desc || '') !== '') {
        this.validateDesc();
      }
    },
    validateName() {
      this.error.name = '';
      if ((this.role.name || '').trim().length === 0) {
        this.error.name = this.$t('auth.roleEdit.pleaseInput');
      }

      if ((this.role.name || '').trim().length > 30) {
        this.error.name = this.$t('auth.roleEdit.overWordLimit');
      }

      return (this.error.name || '') === '';
    },
    validateDesc() {
      this.error.desc = '';
      if ((this.role.desc || '').trim().length > 100) {
        this.error.desc = this.$t('auth.roleEdit.overWordLimit');
      }

      return (this.error.desc || '') === '';
    },
    validate() {
      return [this.validateName(), this.validateDesc()].every((v) => v);
    },
    async save() {
      if (!this.saving) {
        try {
          this.saving = true;

          if (!this.validate()) {
            return;
          }
          await this.$loading(async () => {
            try {
              if (this.newRole) {
                const result = await PermissionService.CreateRoleAsync(this.role);
                this.role.id = (result || {}).roleId;
                this.$notify.saveSuccess();
                this.$emit('saved');
              } else {
                await PermissionService.UpdateRoleAsync(this.role);
                this.$notify.saveSuccess();
                this.$emit('saved');
                // 重新整理頁面已取得新的功能設置
                this.$router.go(0);
              }
            } catch (err) {
              this.$notify.saveFailed();
            }
          });
        } finally {
          this.saving = false;
        }
      }
    },
    deleteRole() {
      if (!this.newRole) {
        if (this.role.userCount > 0) {
          this.$popup.alert(this.$t('auth.roleEdit.disableDelete'));
        } else {
          this.$emit('delete', this.role);
        }
      }
    },
    different() {
      return this.role.name !== this.origin.name
      || this.role.desc !== this.origin.desc
      || !this.compareFeatures();
    },
    compareFeatures() {
      function compareChidren(origin, current) {
        if ((origin || {}).length !== (current || {}).length) {
          return false;
        }

        return Array.prototype.every.call(origin, (val, index) => {
          const cVal = current[index];
          if (val.id === cVal.id) {
            return compareChidren(val.children, cVal.children);
          }
          return false;
        });
      }

      const result = compareChidren(this.origin.features, this.role.features);
      return result;
    }
  }
};
</script>
